<template>
 <v-row row wrap>

    <v-col cols="12" sm="6" md="3">
        <v-select
            v-model="selectedCompanyId"
            :items="companies"
            item-text="razonSocial"
            item-value="id"
            :label="$t('admin.inviraUser.labels.company')"
            clearable
            @change="onCompanyChange"
        ></v-select>
    </v-col>

    <v-col cols="12" sm="6" md="3" offset-md="6">
        <search-input  @search="performSearch" v-model="search" />
    </v-col>

    <v-col cols="12">

       <div class="table-fixed-header-wrap">
       <v-data-table
                class="mt-3"
                fixed-header
                height="calc(100vh - 300px)"
                :headers="headers"
                :items="items"
                :search="search"
                :single-expand="false"
                :server-items-length="totalItems"
                :loading="loading"
                :page.sync="pageNumber"
                :items-per-page.sync="itemsPerPage"
                :sort-by.sync="orderBy"
                :sort-desc.sync="orderDesc"
                :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                @update:page="fetch"
                @update:sort-by="fetch"
                @update:sort-desc="fetch"
                @update:items-per-page="fetch"
        >

            <template slot="no-data">
               <div class="text-xs-center" v-t="'common.noData'"></div>
            </template>

            <template slot="loading">
               <div   class="text-xs-center" v-t="'common.loading'"></div>
            </template>

            <template v-slot:item.company="{ item }">
                {{ item.company ? item.company.razonSocial : '-' }}
            </template>

            <template v-slot:item.role="{ item }">
                <v-chip v-if="item.role" small class="mr-1">
                    {{ item.role.name }}
                </v-chip>
            </template>

            <template v-slot:item.active="{ item }">
                <v-chip small :color="item.active ? 'success' : 'error'">
                    {{ item.active ? $t('common.active') : $t('common.inactive') }}
                </v-chip>
            </template>

            <template v-slot:item.updatedAt="{ item }">
                {{ getDateTimeFormat(item.updatedAt) }}
            </template>

            <template v-slot:item.action="{ item }">
                <show-button  @click="$emit('show', item)" />
                <edit-button  @click="$emit('update', item)" />
                <!-- <delete-button @click="$emit('delete', item)" /> -->
            </template>

        </v-data-table>
       </div>
    </v-col>
</v-row>
</template>

<script>
   import UserProvider from "../../../providers/UserProvider";
   import CompanyProvider from "../../../providers/CompanyProvider";
   
   import { EditButton, ShowButton, SearchInput} from "@dracul/common-frontend"
   import { DayjsMixin } from "@dracul/dayjs-frontend";
    
   
    export default {
        name: "InviraUserList",
        components: { EditButton, ShowButton, SearchInput},
        mixins: [DayjsMixin],
        
        data() {
            return {
                items: [],
                totalItems: null,
                loading: false,
                orderBy: 'updatedAt',
                orderDesc: true,
                itemsPerPage: 5,
                pageNumber: 1,
                search: '',
                selectedCompanyId: null,
                companies: []
            }
        },
        computed: {   
          headers () {
            return [
                    //Entity Headers
                    {text: this.$t('admin.inviraUser.labels.username'), value: 'username'},
                    {text: this.$t('admin.inviraUser.labels.email'), value: 'email'},
                    {text: this.$t('admin.inviraUser.labels.company'), value: 'company', sortable: false},
                    {text: this.$t('admin.inviraUser.labels.role'), value: 'role', sortable: false},
                    {text: this.$t('admin.inviraUser.labels.active'), value: 'active', sortable: false},
                    {text: this.$t('admin.inviraUser.labels.updatedAt'), value: 'updatedAt'},
                    //Actions
                    {text: this.$t('common.actions'), value: 'action', sortable: false},
                ]
          },
          getOrderBy(){
              return  (Array.isArray(this.orderBy)) ? this.orderBy[0]: this.orderBy
          },
          getOrderDesc(){
              return  (Array.isArray(this.orderDesc)) ? this.orderDesc[0]: this.orderDesc
          } 
        },
        created() {
            this.loadCompanies()
            this.fetch()
        },
        methods:{
            loadCompanies() {
                CompanyProvider.fetchCompanies()
                    .then(r => {
                        this.companies = r.data.companyFetch || []
                    })
                    .catch(err => console.error(err))
            },
            onCompanyChange() {
                this.pageNumber = 1
                this.fetch()
            },
            performSearch(){
                this.pageNumber = 1
                this.fetch()
            },
            fetch() {
                this.loading = true
                UserProvider.paginateUsers(
                    this.selectedCompanyId,
                    this.pageNumber, 
                    this.itemsPerPage,
                    this.search,
                    this.getOrderBy, 
                    this.getOrderDesc
                ).then(r => {
                    this.items = r.data.adminUserPaginate.users
                    this.totalItems = r.data.adminUserPaginate.totalItems
                }).catch(err => {
                    console.error(err)
                }).finally(() => this.loading = false)
            }
        }
        
    }
</script>

<style scoped>
.table-fixed-header-wrap {
  min-height: 0;
}
</style>
